module.exports = __webpack_public_path__ + "img/spadeAct.60b793ea.webp";